/* global XMLHttpRequest */
const igDonationContainer = document.querySelector('.ig_donation')

if (igDonationContainer) {
  // pages and indicators
  window.pages = igDonationContainer.querySelectorAll('.pages .page')
  window.pageIndicatorContainer = igDonationContainer.querySelector('.steps')
  window.pageIndicators = igDonationContainer.querySelectorAll('.steps .step')

  // navigation buttons
  window.nextButton = igDonationContainer.querySelector('.next')
  window.backButton = igDonationContainer.querySelector('.back')

  // api endpoint urls
  const validationEndpoint = igDonationContainer.getAttribute('data-validation-endpoint')

  // global variables
  window.currentPage = 0
  window.typingTimersObject = {}
  window.typingTimeout = 500

  /**
   * Displays the specified page.
   *
   * @param {*} number Number of the page (starting at 0)
   */
  window.goToStep = number => {
    // never jump to disabled pages
    if (window.pages[number].classList.contains('disabled')) {
      if (number < window.currentPage) {
        number = number - 1
      } else {
        number = number + 1
      }
    }

    window.currentPage = number

    // reset states
    window.pages.forEach(page => page.classList.remove('active'))
    window.pageIndicators.forEach(indicator => indicator.classList.remove('active'))
    window.backButton.classList.remove('d-none')

    // hide back button on first page
    if (window.currentPage === 0) window.backButton.classList.add('d-none')

    // show specified page
    window.pages[number].classList.add('active')
    window.pageIndicators[number].classList.add('enabled')
    window.pageIndicators[number].classList.add('active')

    // set next button text based on current page
    if (window.currentPage === (window.pages.length - 1)) {
      window.nextButton.innerText = window.nextButton.getAttribute('data-submit')
    } else {
      window.nextButton.innerText = window.nextButton.getAttribute('data-default')
    }
  }

  /**
   * Validates a field with the backend after the user has stopped typing.
   *
   * @param {*} inputElement
   * @param {*} validationObject
   */
  window.waitUntilUserHasFinishedTypingAndValidateField = (
    inputElement,
    validationObject
  ) => {
    clearTimeout(window.typingTimersObject[inputElement.name])

    window.typingTimersObject[inputElement.name] = setTimeout(
      () => {
        window.validateFieldWithBackend(
          response => {
            if (response === 'false') {
              window.setFieldInvalid(inputElement)
            } else {
              window.setFieldValid(inputElement)
            }
          },
          inputElement.value,
          validationObject.type,
          validationObject.arguments
        )
      },
      window.typingTimeout
    )
  }

  /**
   * Uses `window.post()` to validate a input with TYPO3.
   *
   * @param {*} callback The callback function
   * @param {string} fieldValue The content of the field
   * @param {string} fieldType Type of field (see possible fields in backend)
   * @param {string} validationArgs Additional validation restrictions
   */
  window.validateFieldWithBackend = (
    callback,
    fieldValue,
    fieldType,
    validationArgs
  ) => {
    window.post(
      callback,
      validationEndpoint,
      {
        type: fieldType,
        value: fieldValue,
        args: validationArgs
      }
    )
  }

  /**
   * Sends POST data to a given URL and calls callback with result.
   *
   * @param {*} callback The callback function
   * @param {*} url The URL
   * @param {*} object The object that should be send to the URL
   */
  window.post = (callback, url, object) => {
    const http = new XMLHttpRequest()

    http.open('POST', url, true)
    http.setRequestHeader('Content-type', 'application/json')
    http.onreadystatechange = () => {
      if (http.status === 200 && http.readyState === 4) {
        callback(http.responseText)
      } else if (http.status !== 200 && http.readyState === 4) {
        throw new Error('Invalid response from endpoint: ' + url)
      }
    }
    http.send(JSON.stringify(object))
  }

  /**
   * Returns the selected donation distance.
   *
   *
   * @returns {number}
   */
  window.getDonationDistance = function() {
    let distance = 0

    if(igDonationContainer.querySelectorAll('.run-suggestions').length >= 1){
      igDonationContainer.querySelectorAll('.run-suggestions input').forEach(element => {
        if (element.checked) {
          distance = element.getAttribute('data-distance')
        } else if (element.value > 0) {
          distance = element.value
        }
      })
    }

    return parseInt(distance)
  }

  /**
   * Returns the selected donation amount.
   *
   * @param {boolean} asCents
   *
   * @returns {number}
   */
  window.getDonationAmount = asCents => {
    let amount = 0

    igDonationContainer.querySelectorAll('.amount-suggestions input').forEach(element => {
      if (element.checked) {
        amount = element.getAttribute('data-amount')
      } else if (element.value > 0) {
        amount = element.value
      }
    })

    if (asCents) {
      amount = amount * 100
    }

    return parseInt(amount)
  }

  /**
   * Returns the friendly name or ID of the selected payment rhythm.
   *
   * @param {boolean} humanReadable Return human readable name instead of ID
   *
   * @returns {string}
   */
  window.getDonationRhythm = humanReadable => {
    let donationRhythm = ''

    igDonationContainer.querySelectorAll('.rhythms input').forEach(element => {
      if (element.checked) {
        if (humanReadable) {
          donationRhythm = element.parentElement.querySelector('label').innerText
        } else {
          donationRhythm = element.getAttribute('data-rhythm-key')
        }
      }
    })

    return donationRhythm
  }

  /**
   * Enables the desired payment methods.
   *
   * @param {object} methodsToEnable Must include the payment methods to be activated
   */
  window.definePossiblePaymentMethods = methodsToEnable => {
    igDonationContainer.querySelectorAll('.payment-methods [name=payment_methods]').forEach(element => {
      element.parentElement.classList.add('disabled')
      element.disabled = true
      element.checked = false
    })

    for (const key in methodsToEnable) {
      if (methodsToEnable[key]) {
        const inputElement = document.querySelector(`#${key}`)
        if(inputElement) {
            inputElement.disabled = false
            inputElement.parentElement.classList.remove('disabled')
        }
      }
    }
  }

  /**
   * Adds the `validation-error` class and removes `is-valid`.
   *
   * @param {object} element The element to modify
   */
  window.setFieldInvalid = element => {
    element.classList.add('validation-error')
    element.classList.remove('is-valid')
    if(element.classList.contains('input-birthday')) {
        window.checkBirthdayErrors()
    }
  }

  window.validateEmail = email => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email)
  }

  window.validateStringLength = (string, min, max) => {
    return string.length >= min && string.length <= max
  }

  /**
   * Removes the `validation-error` class and adds `is-valid`.
   *
   * @param {object} element The element to modify
   */
  window.setFieldValid = element => {
    element.classList.add('is-valid')
    element.classList.remove('validation-error')
      if(element.classList.contains('input-birthday')) {
          window.checkBirthdayErrors()
      }
  }

  window.scrollToSmoothly = (pos, time) => {
    const currentPos = window.scrollY || window.screenTop

    if (currentPos < pos) {
      let t = 10

      for (let i = currentPos; i <= pos; i += 10) {
        t += 10
        setTimeout(() => {
          window.scrollTo(0, i)
        }, t / 2)
      }
    } else {
      time = time || 2
      let i = currentPos
      let x

      x = setInterval(() => {
        window.scrollTo(0, i)
        i -= 10

        if (i <= pos) {
          clearInterval(x)
        }
      }, time)
    }
  }

  window.getPos = element => {
    let x = 0
    let y = 0

    while (true) {
      x += element.offsetLeft
      y += element.offsetTop

      if (element.offsetParent === null) {
        break
      }

      element = element.offsetParent
    }

    return [x, y]
  }

  // show first page on load
  window.goToStep(0)
}
